import axios from 'axios'
import { Notification, Message } from 'element-ui' //引入element-ui库
import store from '@/store';
// 创建axios实例
const service = axios.create({
    baseURL: 'https://www.chaoyipingtools.com/', // 设置请求的基本URL
    timeout: 5000, // 请求超时时间
    withCredentials: false, //表示跨域请求时是否需要使用凭证
})

service.interceptors.request.use(
    config => {
        const token = store.getters.getToken;
        config.headers = {
          'Authorization': token,
          // 'Content-Type': 'application/x-www-form-urlencoded'
          'Content-Type': 'application/json'  // 设置请求头为 JSON

        }
        let nowtime = new Date().getTime()
        if(config.data){
          let arr = Object.keys(config.data)
          if (arr.length > 0) {
              for (let i = 0; i < arr.length; i++) {
                  config.data[arr[i]] = String(config.data[arr[i]])
              }
              
          }
        }
      
      return config
    },
    error => {
        Promise.reject(error)
    }
)

service.interceptors.response.use(response=>{
    const resp = response.data
    if(response.request.responseType == "blob"){
        return response
    }
    return resp
},
error => {
    return Promise.reject(error)
})

export default service;